import React from 'react';
import PropTypes from "prop-types";

export function CsfPivotalFournisseurDelegationTable({delegation, handleModalClick, handleDeleteClick}) {

  return (
    <div className="table-wrapper">
      <table id="formateur-list-table">
        <caption id="formateur-list-caption"
                 className="sr-only">{window.Drupal.t('fournisseur.delegation.title')}</caption>
        <thead>
        <tr>
          <th width="15%">{window.Drupal.t('fournisseur.gestion.table.firstname')}</th>
          <th width="15%">{window.Drupal.t('fournisseur.gestion.table.lastname')}</th>
          <th width="15%">{window.Drupal.t('fournisseur.gestion.status.label')}</th>
          <th>{window.Drupal.t('fournisseur.gestion.table.email')}</th>
          <th width="20%">{window.Drupal.t('fournisseur.delegation.role.col.title')}</th>
          <th width="100"></th>
        </tr>
        </thead>
        <tbody>

        {delegation.length === 0 ? (
          <tr>
            <td colSpan="6">
              <p>{window.Drupal.t('fournisseur.empty.training.list')}</p>
            </td>
          </tr>
        ) : (
          delegation.map((item) => (
            <tr key={item.Contact_Id}>
              <td>{item.First_Name}</td>
              <td>{item.Last_Name}</td>
              <td>
                {item.GSFT_Status_Id ? (
                  item.GSFT_Status_Id === "AAAAAAAAADg=" ? (
                    window.Drupal.t('fournisseur.gestion.status.actif')
                  ) : (
                    window.Drupal.t('fournisseur.gestion.status.inactif')
                  )
                ) : null }
              </td>
              <td>{item.Courriel}</td>
              <td>
                {item.EP_Contact_Role !== null ? (
                item.EP_Contact_Role === 1 ? (
                  window.Drupal.t('fournisseur.delegation.modal.designer.label')
                ) : (
                  window.Drupal.t('fournisseur.delegation.modal.responsible.label')
                )
                ) : null }
              </td>
              <td>
                <div className="buttons-wrapper">
                  <button type="button" className='button btn-outlined btn-icon-only'
                          onClick={() => handleModalClick(item.Contact_Id)} title={window.Drupal.t('Edit')}
                          data-toggle="modal" data-target="#delegationModal">
                    <span className="icon-csf-edit supplier-icon"><span className="d-none">&nbsp;</span></span>
                  </button>
                  <button type="button" className='button btn-outlined btn-icon-only'
                          onClick={() => handleDeleteClick(item.Contact_Id)}
                          data-toggle="modal" data-target="#deleteModal"
                          title={window.Drupal.t('Delete')}>
                    <span className="icon-remove supplier-icon"><span className="d-none">&nbsp;</span></span>
                  </button>
                </div>
              </td>
            </tr>
          )))}
        </tbody>
      </table>
    </div>
  );
}

CsfPivotalFournisseurDelegationTable.propTypes = {
  delegation: PropTypes.array,
  handleModalClick: PropTypes.func,
  handleDeleteClick: PropTypes.func
};
